import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableCarrierAvailable extends Layout {
    sourceCarrierAvailableOrders: DataSource;
    tableAvailable: Table;
}
